import { FC, Fragment, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useUiActionsByResource } from 'hooks'
import { Skeleton } from '@mui/material'
import { Box, MenuItem, Popover, useTheme } from '@mui/material'
import { Button } from 'components'
import { EidWorkflow } from 'packages/eid-ui'
import config from 'config'
import { ArrowIcon } from 'packages/eid-icons'
import { useHistory } from 'react-router'
import { useIsSmallScreen, useQuery } from 'packages/core'
import { handleRenderWorkflow } from 'utils'

export type ActionProps = {
    application: {
        id: string
        resourceID: number
    }
}

export const Actions: FC<ActionProps> = (props) => {
    const { t } = useTranslation()

    const isSmallScreen = useIsSmallScreen()

    const [anchorEl, setAnchorEl] = useState(null)

    const openMenu = (event: any) => {
        setAnchorEl(event.currentTarget)
    }

    const closeMenu = () => {
        setAnchorEl(null)
    }

    const { data, isInitialLoading } = useUiActionsByResource(
        props.application.id,
    )
    const query = useQuery()
    const history = useHistory()
    const theme = useTheme()
    const onClick = (name: any) => {
        handleRenderWorkflow([], name, history)
    }

    return (
        <Box
            sx={{
                minWidth: '177px',
            }}
        >
            {isInitialLoading ? (
                <Skeleton height={40} />
            ) : (
                <Fragment>
                    <Button
                        onClick={openMenu}
                        fullWidth
                        sx={{
                            padding: '4px 16px',
                            color: '#3b454d',
                            fontSize: '14px',
                            textTransform: 'capitalize',
                            backgroundColor: theme?.palette?.background?.paper,
                            border: 'solid 1px #d8d8dd',
                            boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.1)',
                            '& >span': {
                                display: 'flex',
                                justifyContent: 'space-between',
                            },
                            '&:hover': {
                                backgroundColor:
                                    theme?.palette?.background?.paper,
                                border: 'solid 1px #d8d8dd',
                                boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.1)',
                            },
                        }}
                        endIcon={
                            <ArrowIcon
                                color="#aab0b4"
                                direction={Boolean(anchorEl) ? 'up' : 'down'}
                            />
                        }
                    >
                        {t('Common_Actions')}
                    </Button>
                    <Popover
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={closeMenu}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                    >
                        {data.map((d: any) =>
                            isSmallScreen ? (
                                <EidWorkflow
                                    key={d.id}
                                    baseEidUrl={config.BASE_EID_URL}
                                    title={d.friendlyName}
                                    workflowName={d.requestWorkflowName}
                                    workflowParams={[
                                        `SelectedResourceID=${props.application.resourceID}`,
                                    ]}
                                >
                                    <MenuItem
                                        onClick={closeMenu}
                                        sx={{
                                            minWidth: '177px',
                                        }}
                                    >
                                        {d.friendlyName}
                                    </MenuItem>
                                </EidWorkflow>
                            ) : (
                                <MenuItem
                                    key={d.id}
                                    onClick={() => {
                                        closeMenu()
                                        onClick(d.requestWorkflowName)
                                    }}
                                    sx={{
                                        minWidth: '177px',
                                    }}
                                >
                                    {d.friendlyName}
                                </MenuItem>
                            ),
                        )}
                    </Popover>
                </Fragment>
            )}
        </Box>
    )
}
